<template>
  <div class="container">
    <div
      style="position: absolute; top: 302px; left: 0; right: 0; bottom: 0"
      v-if="$store.state.isLoading"
    >
      <Loader color="#0c6b68" :size="163" />
    </div>
    <template v-else>
      <div class="bg-grey" v-if="shoes.length">
        <img
          v-if="shoes[0] && shoes[0].name"
          :src="
            require(`../assets/images/shoe-images/${shoes[0].name
              .split(' ')
              .join('-')}.jpg`)
          "
          :alt="shoes[0].name || 'Shoe'"
          class="big-shoe"
        />
        <img
          v-if="!$store.state.isLoading && shoes.length < 1"
          src="../assets/images/shoe2x.png"
          alt="Shoe"
          class="big-shoe"
        />
        <div class="content">
          <div class="left">
            <p>Your last added Xsensible shoe</p>
            <h4 v-if="shoes[0]">{{ shoes[0].name }}</h4>
            <div v-if="shoe">{{ shoe.description }}</div>
          </div>
          <div class="right">
            <a class="btn btn-black" v-if="shoe" :href="shoe.link">
              Get inspired
            </a>
          </div>
        </div>
      </div>
      <div class="shoe-wrapper" v-show="!$store.state.isLoading">
        <div class="add-card" @click="$router.push('step-1')">
          <span class="points">+500 Xmiles</span>
          <img src="../assets/icons/add.svg" alt="Add your Xsensible" />
          <span class="add-xsensible">Add your Xsensible</span>
        </div>
        <Shoe
          padding-top
          v-for="(shoe, i) in shoes"
          :key="i"
          :shoe="shoe"
          tabindex="0"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { getShoe, getShoeName } from '@/shoeMap'
import Shoe from '@/components/Shoe'
import Loader from '@/components/Loader'

export default {
  name: 'MyXsensibles',
  data() {
    return {
      shoes: []
    }
  },
  mounted() {
    this.$store.commit('setLoading', true)
    this.$store
      .dispatch('getRegisteredShoes')
      .then(shoes => {
        this.shoes = shoes.map(shoe => ({
          ...shoe,
          name: getShoeName(shoe.shoeEANCode)
        }))
      })
      .catch(err => {
        console.log(err)
        this.$store.commit('setLoading', false)
      })
      .finally(() => this.$store.commit('setLoading', false))
  },
  computed: {
    shoe() {
      return this.shoes.length
        ? getShoe(this.shoes[0].name)
        : {
            description: `De trendy combinatie van het frisse kleurpalet en het gegolfde
          design maakt van deze schoen een echte voorjaarstopper. Het zachte
          leer is voorzien van sprankelend metallic en aaibare suède accenten.
          De witte zool met Stretchwalker-balanstechnologie en de rits aan de
          zijkant bieden extra draagcomfort.`
          }
    }
  },
  components: { Shoe, Loader }
}
</script>

<style lang="scss" scoped>
.bg-grey {
  background-color: #efefef;
  margin-bottom: 140px;
  padding: 40px;

  .big-shoe {
    margin-top: 20px;
    margin-bottom: 20px;
    max-width: 100%;
  }

  .content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .left {
      width: 60%;

      p {
        color: #0c6b68;
        font-weight: bold;
      }

      h4 {
        font-size: 36px;
        margin: 10px 0;
      }

      div {
        line-height: 28px;
      }
    }
  }
}

.shoe-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-top: 20px;

  .add-card {
    width: 325px;
    min-height: 400px;
    box-sizing: border-box;
    border: 4px dashed #f5f5f5;
    display: flex;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
    cursor: pointer;
    margin: 0 auto;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .points {
      align-self: flex-start;
      justify-self: flex-end;
      margin: 10px 10px auto auto;
      background-color: #e4ede9;
      padding: 10px 20px;
    }

    .add-xsensible {
      align-self: flex-end;
      padding: 25px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 1023px) {
  .container {
    margin-top: 90px;
  }
  .shoe-wrapper {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .container {
    padding: 0;
  }
  .shoe-wrapper {
    grid-template-columns: 1fr;
    padding: 0 20px;

    .add-card {
      height: 375px;
      width: 100%;
    }
  }
  .bg-grey {
    padding: 20px;

    .content {
      .left,
      .right {
        width: 100%;
      }
    }
  }
  .card {
    height: 375px;
  }
  .add-card {
    width: 100%;
    height: auto;
  }
}
</style>
